export default __webpack_public_path__ + "static/media/Group1043.6ceea998.png";